export default __webpack_public_path__ + "static/media/case-study-button.c42ea607.svg";